import { useState } from "react";
import { toast } from "sonner";
import { Download, Check, Loader2 } from "lucide-react";
import { isGameKept, keepGame, forgetGame } from "@/lib/offline";

// « Garder sur la tablette » : le jeu reste jouable sans internet.
export default function KeepGameButton({ item, onChange }) {
  const [kept, setKept] = useState(() => isGameKept(item));
  const [busy, setBusy] = useState(false);
  const toggle = async () => {
    setBusy(true);
    try {
      if (kept) { await forgetGame(item); setKept(false); toast("Jeu retiré de la tablette."); }
      else { await keepGame(item); setKept(true); toast.success("Jeu gardé sur la tablette : il se jouera même sans internet."); }
      onChange?.();
    } catch { toast.error("Impossible de garder ce jeu sur la tablette."); }
    finally { setBusy(false); }
  };
  return (
    <button onClick={toggle} disabled={busy} aria-pressed={kept} data-testid={`keep-game-${item.id}`}
      className={`inline-flex items-center gap-2 h-11 px-5 rounded-full font-patient font-bold border-2 transition-colors disabled:opacity-60 ${kept ? "bg-emerald-700 border-emerald-700 text-white" : "bg-white border-emerald-200 text-emerald-800 hover:bg-emerald-50"}`}>
      {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : kept ? <Check className="w-5 h-5" /> : <Download className="w-5 h-5" />}
      {kept ? "Gardé sur la tablette" : "Garder sur la tablette"}
    </button>
  );
}
